import React from "react";
import { mount, shallow } from "enzyme";
import { get, isArray, isString, filter, values, result } from "lodash";
import { ThemeProvider } from "styled-components";
import moment from "moment";
import theme from "./theme";
import { ERROR_MSG } from "./constant";
import PageNotFound from "./component/PageNotFound";
import { PROJECT_STATUS } from "./container/createProject/helper";
import { text } from "@fortawesome/fontawesome-svg-core";
import { toast } from "react-toastify";
import { Event } from "jquery";
import Keycloak from "keycloak-js";
import { projectLabelConstant } from "./projectLabelConstant";
import htmlToFormattedText from "html-to-formatted-text";

export const shallowWithTheme = children => shallow(children, { theme });

/* istanbul ignore next */
export const mountWithTheme = (children, options) =>
  mount(<ThemeProvider theme={theme}>{children}</ThemeProvider>, options);

export const getDayOfTheGivenDate = givenDate => {
  let date = new Date(givenDate);
  return new Intl.DateTimeFormat("default", {
    weekday: "long"
  }).format(date);
};
export const getTimeOfTheGivenDate = givenDateOrTime => {
  let date = new Date(givenDateOrTime);
  let time = new Intl.DateTimeFormat("default", {
    hour12: true,
    hour: "numeric",
    minute: "numeric"
  }).format(date);
  return time.toUpperCase();
};

export const PRAGATIdateFormat = date =>
  date
    ? moment(new Date(date))
        .local()
        .format("MMM DD, YYYY")
    : null;

export const dateFormat = date =>
  date
    ? moment(new Date(date))
        .local()
        .format("DD/MMM/YYYY")
    : null;

export const formatCustomDate = input => {
  const date = new Date(input);

  if (isNaN(date)) return "Invalid Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const escalationTimeFormat = (date, format = "LT") =>
  date
    ? moment(new Date(date))
        .local()
        .format(format)
    : null;
export const dateFormatWithTime = (date, format = "LLLL") =>
  date
    ? moment(new Date(date))
        .local()
        .format(format)
    : null;
export const dateFormatMapping = date => moment(date).toISOString();
export const defaultMaxDate = moment("9999-12-30T18:30:00.000Z").toISOString();

export const nameFromPanDetails = inputValue => {
  const nameFromPan =
    inputValue && inputValue.substring(0, inputValue.indexOf("(")).trim();
  return nameFromPan || null;
};

export const boolToString = bool => {
  return bool ? "Yes" : "No";
};

export const replaceNullWithString = val => {
  return val === null || val === undefined ? "-" : val;
};

export const serialize = obj => {
  const str = [];
  if (Array.isArray(obj)) {
    let keys = obj;
    keys.forEach(value => {
      let key = Object.keys(value)[0];
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(value[key])}`);
    });
  } else {
    let keys = Object.keys(obj);
    keys.forEach(key => {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    });
  }
  return str.join("&");
};

export const removeEmptyArray = data => {
  const original = { ...data };
  const keys = Object.keys(original);
  keys.forEach(key => {
    if (isArray(original[key]) && !original[key].length) {
      delete original[key];
    }
  });
  return original;
};

export const extractId = arr => {
  return arr.map(({ value }) => {
    return value.toString();
  });
};

export const extractIdNumeric = arr => {
  return arr.map(({ value }) => {
    return parseInt(value, 10);
  });
};

export const dayAgo = date => {
  const newDate = moment(date);
  return newDate.from(new Date());
};

export const daysLeft = date => {
  const start = new Date();
  const end = new Date(date);
  start.setHours(0, 0, 0, 0);
  end.setHours(24, 0, 0, 0);
  const differenceInTime = Math.abs(end.getTime() - start.getTime());
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  return Math.ceil(differenceInDays);
};

export const setLocalstorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const normalizeId = id =>
  id !== null && id !== undefined ? Number(id) : null;

export const zeroToEmpty = value => (value === 0 || value === "0" ? "" : value);

export const getLocalstorage = key => {
  return JSON.parse(localStorage.getItem(`${key}`) || null);
};

export const removeItemFromLocalStorage = key => {
  localStorage.removeItem(key);
};

export const fileUrlForPreview = files => {
  const reader = new FileReader();
  const file = files[0];
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
};

export const FormDataForImage = (files = [], key) => {
  const formData = new FormData();
  for (let i in files) {
    formData.append(key, files[i]);
  }
  return formData;
};

export const clearDebounce = param => {
  param && param.cancel && param.cancel();
};

export const isValidArray = param => {
  return isArray(param) && param.length && param;
};

export const scrollToPosition = (param = {}) => {
  window.scroll({
    behavior: "smooth",
    ...param
  });
};

export const transformProjectCategoryId = type => {
  const values = {
    CENTRAL: "Ministry",
    STATE: "State",
    INDUSTRIAL: "Private",
    STATE_DEPARTMENT: "State Department",
    DISTRICT: "District",
    OTHER: "Other",
    CENTRAL_DEPARTMENT: "Central Department",
    PMG: "Ministry"
  };
  return values[type] || type;
};

export const projectFormLabel = (groupId, key, defaultValue) => {
  if (!projectLabelConstant[groupId]) {
    return defaultValue;
  }
  if (!projectLabelConstant[groupId][key]) {
    return defaultValue;
  }
  return projectLabelConstant[groupId][key];
};

export const GROUP_KEYS = {
  CENTRAL: "CENTRAL",
  STATE: "STATE",
  INDUSTRIAL: "INDUSTRIAL",
  STATE_DEPARTMENT: "STATE_DEPARTMENT",
  DISTRICT: "DISTRICT",
  CENTRAL_DEPARTMENT: "CENTRAL_DEPARTMENT",
  PMG: "PMG",
  OTHER: "OTHER"
};

export const modifyDataOfAddIssue = (
  data,
  isProjectAwardedByState = false,
  _status
) => {
  let issues = [];
  get(data, "issueCOList", []).forEach(value => {
    if (isProjectAwardedByState) {
      if (
        (_status &&
          _status === PROJECT_STATUS.DRAFT &&
          (value["groupCategory"] ||
            value["issueCategoryId"] ||
            value["issueDescription"] ||
            value["recipientGroupId"] ||
            value["userId"] ||
            value["title"])) ||
        (value["groupCategory"] &&
          value["issueCategoryId"] &&
          value["issueDescription"] &&
          value["recipientGroupId"] &&
          value["title"]) ||
        (value["bucketId"] &&
          value["milestoneTableId"] &&
          value["milestoneId"]) ||
        value["responsibleAuthority"] ||
        value["secondaryRecipientGroupId"] ||
        value["secondaryRecipientGroup"] ||
        value["proposalNoValidated"]
      ) {
        issues.push({
          id: value["id"],
          groupCategory: value["groupCategory"],
          issueCategoryId: +value["issueCategoryId"],
          //issueDescription: htmlToFormattedText(value["issueDescription"]),
          // issueDescription: value['issueDescription'].replace(
          //   /<p>\s*(<br\s*\/?>)?\s*<\/p>/gi,
          //   ''
          // ),
          issueDescription: value["issueDescription"]
            .replace(
              /(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*){2,}/gi,
              "<p><br></p>"
            )
            .replace(/^(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+/gi, "")
            .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+$/gi, ""),

          recipientGroup: +value["recipientGroupId"],
          issueSubCategoryId: value["issueSubCategoryId"]
            ? +value["issueSubCategoryId"]
            : null,
          title: htmlToFormattedText(value["title"]),
          updatedCreatedById: get(value, "userID.id", null),
          fileManagerList: (value["files"] || []).map(data => {
            return +data.id;
          }),
          dateOfOrder: value["dateOfOrder"] ? value["dateOfOrder"] : null,
          forumId: value["forum"] ? +value["forum"] : null,
          bucketId: value["bucketId"] ? +value["bucketId"] : null,
          milestoneTableId: value["milestoneTableId"]
            ? +value["milestoneTableId"]
            : null,
          milestoneId: value["milestoneId"] ? +value["milestoneId"] : null,
          responsibleAuthority: htmlToFormattedText(
            value["responsibleAuthority"]
          ),
          secondaryRecipientGroup: value["secondaryRecipientGroup"],
          proposalNoValidated: value["proposalNoValidated"]
        });
      }
    } else {
      if (
        (_status &&
          _status === PROJECT_STATUS.DRAFT &&
          (value["groupCategory"] ||
            value["issueCategoryId"] ||
            value["issueDescription"] ||
            value["userId"] ||
            value["selectedStateId"] ||
            value["escalationLevel"] ||
            value["reasonForEscalation"] ||
            value["stateDistrictAndDepartment"] ||
            value["selectedMinistryId"] ||
            value["ministryDistrictAndDepartment"] ||
            value["title"])) ||
        (value["groupCategory"] &&
          value["issueCategoryId"] &&
          value["issueDescription"] &&
          value["title"]) ||
        (value["bucketId"] &&
          value["milestoneTableId"] &&
          value["milestoneId"]) ||
        value["responsibleAuthority"]
      ) {
        let recipientGroupId = null;
        let districtId = null;
        let centerStateId = null;
        let centerDistrictId = null;
        if (value["groupCategory"] === GROUP_KEYS.STATE) {
          recipientGroupId = value["selectedStateId"];
          districtId = value["stateDistrictAndDepartment"];
        } else {
          recipientGroupId = value["selectedMinistryId"];
          districtId = value["ministryDistrictAndDepartment"];
          centerStateId = +value["selectedStateId"];
          centerDistrictId = +value["stateDistrictAndDepartment"];
        }
        issues.push({
          id: value["id"],
          groupCategory: value["groupCategory"],
          issueCategoryId: +value["issueCategoryId"],
          //issueDescription: htmlToFormattedText(value["issueDescription"]),
          // issueDescription: value['issueDescription'].replace(
          //   /<p>\s*(<br\s*\/?>)?\s*<\/p>/gi,
          //   ''
          // ),
          issueDescription: value["issueDescription"]
            .replace(
              /(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*){2,}/gi,
              "<p><br></p>"
            )
            .replace(/^(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+/gi, "")
            .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+$/gi, ""),

          recipientGroup: +recipientGroupId,
          issueSubCategoryId: value["issueSubCategoryId"]
            ? +value["issueSubCategoryId"]
            : null,
          district: +districtId,
          title: htmlToFormattedText(value["title"]),
          escalationLevel: value["escalationLevel"],
          reasonForEscalation: value["reasonForEscalation"],
          updatedCreatedById: get(value, "userID.id", null),
          fileManagerList: (value["files"] || []).map(data => {
            return +data.id;
          }),
          dateOfOrder: value["dateOfOrder"] ? value["dateOfOrder"] : null,
          forumId: value["forum"] ? +value["forum"] : null,
          bucketId: value["bucketId"] ? +value["bucketId"] : null,
          milestoneTableId: value["milestoneTableId"]
            ? +value["milestoneTableId"]
            : null,
          milestoneId: value["milestoneId"] ? +value["milestoneId"] : null,
          responsibleAuthority: htmlToFormattedText(
            value["responsibleAuthority"]
          ),
          proposalNoParivesh: value["proposalNoParivesh"],
          centerState: centerStateId,
          centerDistrict: centerDistrictId,
          proposalNoValidated: value["proposalNoValidated"]
        });
      }
    }
  });
  return issues;
};

export const editDataOfAddIssue = data => {
  const issues = [];
  get(data, "issueCOList", []).forEach(value => {
    let selectedStateId = null;
    let stateDistrictAndDepartment = null;
    let selectedMinistryId = null;
    let ministryDistrictAndDepartment = null;
    if (value["recipientGroupCategory"] === "STATE") {
      selectedStateId = value["recipientGroupId"];
      stateDistrictAndDepartment = value["districtDeptId"]
        ? value["districtDeptId"]
        : value["districtName"];
    } else {
      selectedMinistryId = value["recipientGroupId"];
      ministryDistrictAndDepartment = value["districtDeptId"]
        ? value["districtDeptId"]
        : value["districtName"];
      selectedStateId = value["centerStateId"];
      stateDistrictAndDepartment = value["centerDistrictId"];
    }
    issues.push({
      groupCategory: value["recipientGroupCategory"],
      issueCategoryId: value["issueCategoryId"],
      //issueDescription: htmlToFormattedText(value["description"]),
      // issueDescription: value['description'].replace(
      //   /<p>\s*(<br\s*\/?>)?\s*<\/p>/gi,
      //   ''
      // ),
      issueDescription: value["description"]
        .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*){2,}/gi, "<p><br></p>")
        .replace(/^(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+/gi, "")
        .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+$/gi, ""),
      issueSubCategoryId: value["issueSubcategoryId"],
      previousCreatedBy: value["previousCreatedBy"],
      stateUserAutocompleteDTO: value["stateUserAutocompleteDTO"],
      recipientGroupId: value["recipientGroupId"],
      title: htmlToFormattedText(value["title"]),
      updatedCreatedById: get(value, "userID.id", null),
      fileManagerList: value["files"] || [],
      recipientGroupCategory: value["recipientGroupCategory"],
      recipientGroup: value["recipientGroup"],
      showSubcategory: value["showSubcategory"],
      id: value["id"],
      recipientGroupParentId: value["recipientGroupParentId"],
      childIssue: value["childIssue"],
      dateOfOrder: value["dateOfOrder"] ? value["dateOfOrder"] : null,
      forum: value["forum"] ? +value["forum"].id : null,
      forumName: value["forum"] ? value["forum"].name : null,
      bucketId: value["bucket"] ? value["bucket"].id : null,
      milestoneTableId: value["milestoneTable"]
        ? value["milestoneTable"].id
        : null,
      milestoneId: value["milestone"] ? value["milestone"].id : null,
      responsibleAuthority: htmlToFormattedText(value["responsibleAuthority"]),
      proposalNoParivesh: value["proposalNoParivesh"],
      proposalNoValidated: value["proposalNoValidated"],
      escalationLevel: value["escalationLevel"],
      reasonForEscalation: value["reasonForEscalation"],
      escalationLevelName: value["escalationLevelName"],
      selectedStateId,
      stateDistrictAndDepartment,
      selectedMinistryId,
      ministryDistrictAndDepartment,
      secondaryStateId: value["secondaryStateId"],
      secondaryStateDepartmentId: value["secondaryStateDepartmentId"],
      secondaryMinistryId: value["secondaryMinistryId"],
      secondaryMinistryDepartmentId: value["secondaryMinistryDepartmentId"],
      secondaryRecipientGroupId: value["secondaryRecipientGroupId"],
      secondaryRecipientGroupName: value["secondaryRecipientGroupName"],
      secondaryRecipientGroup: value["secondaryRecipientGroupId"],
      issueSecondaryRecipientEditable: value["issueSecondaryRecipientEditable"]
    });
  });
  return issues;
};

export function removeNull(obj) {
  Object.keys(obj).forEach(key => {
    if (
      obj[key] &&
      typeof obj[key] === "object" &&
      ((Array.isArray(obj[key]) && obj[key].length) ||
        Object.keys(obj[key]).length)
    ) {
      removeNull(obj[key]);
    }
    if (obj[key] === undefined || obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
}

export const replaceCharacterWith = (text, replaceChar, replaceWith) => {
  if (typeof text === "string") {
    const regex = new RegExp(`${[replaceChar]}`);
    return (text && text.replace(regex, replaceWith)) || "";
  }
  return text;
};

export const getColor = type => {
  const colorCode = {
    "under consideration": "color-orange",
    "under process": "color-purple",
    "under decision": "color-blue",
    "pending with sm": "color-juniper",
    "pending with pmg": "color-orange",
    "pending with rm/rs": "color-purple",
    "on hold": "color-yellow",
    hold: "color-yellow",
    "under verification": "color-juniper",
    verified: "color-green",
    duplicate: "color-orange",
    resolved: "color-green",
    juniper: "color-juniper",
    rejected: "color-red",
    reject: "color-red",
    "under construction": "color-juniper",
    open: "color-blue",
    commissioned: "color-comissioned",
    "partially commissioned": "color-orange",
    "pending with ss": "color-grayish-cyan",
    // "pending with state pmg": "color-brown",
    "pending with spmg/sd": "color-brown",
    "pending with rd": "color-magenta",
    "under state pmg decision": "color-medium-blue",
    "under central pmg": "color-yellow-green",
    terminated: "bg-color-light-orange",
    foreclosed: "bg-color-code-orange"
  };
  return colorCode[isString(type) && type.toLowerCase()] || "color-blue";
};

export const getColorCode = type => {
  const colorCode = {
    "under consideration": "color-code-orange",
    "under process": "color-code-purple",
    "under decision": "color-code-blue",
    "pending with sm": "color-code-juniper",
    "pending with pmg": "color-code-orange",
    "pending with rm/rs": "color-code-purple",
    hold: "color-code-yellow",
    duplicate: "color-code-orange",
    resolved: "color-code-green",
    juniper: "color-code-juniper",
    reject: "color-code-red",
    "under construction": "color-code-juniper",
    open: "color-code-blue",
    commissioned: "color-code-comissioned",
    "partially commissioned": "color-code-orange",
    "pending with ss": "color-code-grayish-cyan",
    // "pending with state pmg": "color-code-brown",
    "pending with spmg/sd": "color-code-brown",
    "pending with rd": "color-code-magenta",
    "under state pmg decision": "color-code-medium-blue",
    "under central pmg": "color-code-yellow-green",
    verified: "color-code-green",
    "on hold": "color-code-yellow",
    "under verification": "color-code-juniper",
    rejected: "color-code-red"
  };
  return colorCode[isString(type) && type.toLowerCase()] || "color-blue";
};

export const getBackgroundColorCode = type => {
  const colorCode = {
    verified: "bg-color-code-green",
    "on hold": "bg-color-code-yellow",
    "under verification": "bg-color-code-juniper",
    rejected: "bg-color-code-red",
    terminated: "bg-color-light-orange",
    "iig draft": "bg-color-congress-blue",
    foreclosed: "bg-color-code-orange",
    "crip draft": "bg-color-congress-blue"
  };
  return colorCode[isString(type) && type.toLowerCase()] || "color-blue";
};

export { theme };

export const formatNumber = num => {
  const localeString =
    num &&
    num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "decimal",
      currency: "INR"
    });
  return localeString;
};

const currencyFormatter = function(amount, splitBy) {
  return (
    amount &&
    parseInt(amount)
      .toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        style: "currency",
        currency: "INR"
      })
      .replace(/,/g, splitBy || ",")
  );
};

export const formatNumberOnDashBoard = (num, conversion, prefix, splitBy) => {
  let amount = num.toLocaleString().substr(0, 3),
    cost = currencyFormatter(num, splitBy);
  if (conversion && num) {
    if (parseInt(num) >= 100000) {
      return cost.substr(0, 5) + (prefix ? " Lakh Cr." : "");
    } else if (parseInt(num) <= 100000 && parseInt(num) >= 1000) {
      return cost.substr(0, 5) + (prefix ? " Thousand Cr." : "");
    } else {
      return currencyFormatter(num, splitBy) + " Cr.";
    }
  } else {
    return currencyFormatter(num, splitBy);
  }
};

export const PERMISSIONS_BY_MODULE = permissions => {
  const extractPermissions = {};
  isValidArray(permissions) &&
    permissions.forEach(permission => {
      extractPermissions[permission.name] = true;
    });
  return extractPermissions;
};

export const isAuthenticated = () => {
  const token = getLocalstorage("token");
  if (!token) {
    return false;
  } else {
    return true;
  }
};

export const isAuthenticatedAsync = async () => {
  return isAuthenticated();
};

export const sortBy = (array, key, order) => {
  let sortedArray = [...array];
  sortedArray.sort((a, b) => {
    if (order === "asc") {
      if (a[key] > b[key]) return -1;
      if (a[key] < b[key]) return 1;
    } else {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
    }
    return 0;
  });
  return sortedArray;
};

///
export const validateDuplicatedIssue = issueCOList => {
  if (isValidArray(issueCOList)) {
    let isDuplicatedProject = false;
    const length = issueCOList.length;
    for (let index = 0; index < length; index++) {
      const firstIssue = issueCOList[index];
      for (let inner = index + 1; inner < length; inner++) {
        const nextIssue = issueCOList[inner];
        isDuplicatedProject =
          firstIssue["issueCategoryId"] == nextIssue["issueCategoryId"] &&
          firstIssue["groupCategory"] == nextIssue["groupCategory"] &&
          firstIssue["issueId"] == nextIssue["issueId"] &&
          firstIssue["issueSubCategoryId"] == nextIssue["issueSubCategoryId"] &&
          firstIssue["recipientGroupId"] == nextIssue["recipientGroupId"] &&
          firstIssue["title"] == nextIssue["title"];
        if (isDuplicatedProject) {
          break;
        }
      }
      if (isDuplicatedProject) {
        break;
      }
    }
    return {
      error: isDuplicatedProject,
      message: ERROR_MSG.DUPLICATED_ISSUES
    };
  }
  return null;
};

export const PromisesHelper = apiArr => {
  return Promise.all(apiArr)
    .then(data => {
      return data;
    })
    .catch(e => {
      return e;
    });
};

export const ScrollToView = (elem, prop) => {
  elem &&
    elem.scrollIntoView({
      behavior: "smooth",
      block: "start",
      ...prop
    });
};

export const AGENDA_FACET_MAPPER = key => {
  // return if key is empty string or key is not a string
  if (!key || !isString(key)) {
    return "";
  }
  const lowercase = key.toLowerCase();
  const keys = {
    withminutes: "With Minutes",
    withoutminutes: "Without Minutes",
    reject: "Rejected",
    resolved: "Resolved",
    hold: "On Hold",
    "ON-Hold": "On Hold"
  };

  return keys[lowercase];
};

export const DATE_COVERSION = obj => {
  if (!get(obj, "from") || !get(obj, "to")) {
    return obj;
  }
  return {
    from: moment(
      new Date(
        get(obj, "from").getFullYear(),
        get(obj, "from").getMonth(),
        get(obj, "from").getDate(),
        0,
        0,
        0
      )
    )
      .utc()
      .valueOf(),
    to: moment(
      new Date(
        get(obj, "to").getFullYear(),
        get(obj, "to").getMonth(),
        get(obj, "to").getDate(),
        23,
        59
      )
    )
      .utc()
      .valueOf()
  };
};

export const FILTER_MAPPER = function(key, type) {
  const Mapper = {
    sponsoringMinistry: `${type} Sponsoring Ministry`,
    sponsoringDepartment: `${type} Sponsoring Department`,
    sponsoringState: `${type} Sponsoring State`,
    mom: "Issue Type",
    stages: "Issue Stages",
    pragatiReview: "Pragati Review",
    category: "Issue category",
    pmg: "PMG",
    assignedToCenter: "Assigned to Ministry",
    assignedToState: "Assigned To State",
    createdByMinistry: "Created By Ministry",
    projectCost: "Project Cost",
    projectScheme: "project Scheme",
    WithMinutes: "With Minutes",
    WithOutMinutes: "Without Minutes",
    reject: "Rejected",
    resolved: "Resolved",
    hold: "On Hold",
    "ON-Hold": "On Hold",
    projectIdFilter: "Project ID/Title",
    projectGroupBy: "Group By"
  };

  return Mapper[key] || null;
};

const singleValueArrayName = {
  pragatiReview: "Pragati Review",
  pmg: "PMG",
  projectGroupBy: "Project"
};

export const FILTER_SORTED_DATA = function(oldData = {}, data) {
  const filterConcat = { ...data, ...oldData };
  const newFilter = {};

  // if filter is not an array
  Object.keys(filterConcat).forEach(key => {
    //
    const currentData = isValidArray(filterConcat[key])
      ? filterConcat[key]
      : [filterConcat[key]];
    newFilter[key] = [];

    //
    if (isValidArray(currentData)) {
      currentData.forEach((value, index) => {
        const isValidFilter = isValidArray(data[key]); // in current filter list
        const oldDataExist = oldData && oldData[key] ? oldData[key][index] : {}; //
        const name =
          singleValueArrayName[key] ||
          get(value, "key", "").substr(
            get(value, "key", "").indexOf("-") + 1,
            get(value, "key", "").length
          );
        const count = !isValidFilter
          ? singleValueArrayName[key]
            ? data[key]
              ? data[key]["count"]
              : 0
            : 0
          : data[key][index]
          ? data[key][index]["count"]
          : oldDataExist && oldDataExist.count;
        newFilter[key].push({
          id: parseInt(value.key) || value.key,
          name,
          ...oldDataExist,
          ...value,
          count
        });
      });
    }
  });

  return newFilter;
};

export const SORT_BY = function(name) {
  const filterArray = {};
  switch (name) {
    case "maximum":
      filterArray.sortBy = "PENDING_DAYS";
      filterArray.sortOrder = "ASC";
      break;
    case "minimum":
      filterArray.sortBy = "PENDING_DAYS";
      filterArray.sortOrder = "DESC";
      break;
    case "high":
      filterArray.sortBy = "PROJECT_COST";
      filterArray.sortOrder = "DESC";
      break;
    case "low":
      filterArray.sortBy = "PROJECT_COST";
      filterArray.sortOrder = "ASC";
      break;
    case "latest":
      filterArray.sortBy = "CREATED_DATE";
      filterArray.sortOrder = "DESC";
      break;
    case "old":
      filterArray.sortBy = "CREATED_DATE";
      filterArray.sortOrder = "ASC";
      break;
    default:
      break;
  }
  return filterArray;
};

export const getProp = prop => {
  return this.hasOwnProperty(prop);
};

export const addIssueDataFormating = data => {
  try {
    return data.map(value => {
      return {
        fileManagerList: [0],
        groupCategory: "PP",
        issueCategoryId: 0,
        issueDescription: "string",
        issueSubCategoryId: 0,
        recipientGroup: 0,
        title: "string",
        updatedCreatedById: 0
      };
    });
  } catch (e) {
    console.log("Error=================", e);
  }
};

export const debounce = function(callback = () => {}, timeout = 0) {
  //
  let callApi = null;
  //
  function call() {
    callApi = setTimeout(callback, timeout);
  }
  //
  call.__proto__.cancel = function() {
    clearTimeout(callApi);
  };

  return call.bind(this);
};

export const searchByValueHelper = function(
  arrOfValue = [],
  searchByText = "",
  arrOfKeys = []
) {
  if (!isValidArray(arrOfValue) || !isValidArray(arrOfKeys)) {
    return arrOfValue;
  }
  const regex = RegExp(searchByText, "ig");
  [...arrOfValue].forEach(value => {
    arrOfKeys.forEach(key => {
      const keyValue = getPropValueHelper(value, key);
      value.display = regex.test(keyValue);
    });
  });
  return arrOfValue;
};

export const getPropValueHelper = function(objectToIterate = {}, keyName = "") {
  // return if object is null
  if (!objectToIterate || !keyName) {
    return null;
  }

  // return prop if exist
  if (objectToIterate[keyName]) {
    return objectToIterate[keyName];
  }
  // search on object
  const entries = Object.entries(objectToIterate);
  entries.forEach(value => {
    const keyValue = value[1];
    if (typeof keyValue === "object") {
      if (Array.isArray(keyValue)) {
        keyValue.forEach(innerValue => {
          if (typeof keyValue === "object") {
            getPropValueHelper(innerValue, keyName);
          }
          return null;
        });
      } else {
        getPropValueHelper(keyValue, keyName);
      }
    }
  });
};

/**
 *
 * @param arrayOfObjects => iterate on array
 * @param findBy => any specific value which need to be find by
 */
export const addPropInObjectHelper = function(
  arrayOfObjects = [],
  findBy = {}
) {
  try {
    // return
    if (!isValidArray(arrayOfObjects) || !findBy) {
      return arrayOfObjects;
    }
    // find the matched element
    const entries = Object.entries(findBy);
    const [key, value] = isValidArray(entries) ? entries[0] : [];

    // props is not defined
    return arrayOfObjects.find(obj => {
      const getElementValue = getPropValueHelper(obj, key);
      return getElementValue === value;
    });
  } catch (e) {
    console.log("ADD PROP IN PROJECT: ", e.message);
  }
};

export const NOTIFICATION_MAPPER = {
  _ENABLE: "ENABLE",
  _DISABLE: "DISABLE"
};

/**
 *
 * @param {*} obj
    it will remove null undefiend and empty array
 */
export function RemoveEmptyFieldsHelper(obj) {
  Object.keys(obj).forEach(key => {
    if (
      obj[key] === false ||
      obj[key] === null ||
      obj[key] === undefined ||
      (Array.isArray(obj[key]) && !obj[key].length)
    ) {
      obj.hasOwnProperty(key) && delete obj[key];
    } else if (typeof obj[key] === "object") {
      return RemoveEmptyFieldsHelper(obj[key]);
    }
  });
  return obj;
}

export const transformProjectListPayload = (payload = {}) => {
  const {
    projectStage = [],
    projectTags = [],
    projectFlags = [],
    projectCost = [],
    sponsoringMinistry = [],
    sponsoringDepartment = [],
    projectSector = [],
    recipientMinistry = [],
    projectImplementationMode = [],
    sponsoringState = [],
    recipientDistDept = [],
    delayedProject = [],
    issueAgeing = [],
    costOverRun = [],
    projectProponent = [],
    bucket = [],
    milestone = [],
    bucketStatus = [],
    milestoneStatus = [],
    projectLocation = [],
    projectZones = [],
    districtProjectLocation = []
  } = payload;

  const newpayload = {
    ...payload,
    projectStage: projectStage.map(value => value.key),
    projectFlags: projectFlags.map(value => value.key),
    projectTags: projectTags.map(value => value.key),
    sponsoringMinistry: sponsoringMinistry.map(value => value.key),
    sponsoringDepartment: sponsoringDepartment.map(value => value.key),
    sponsoringState: sponsoringState.map(value => value.key),
    projectSector: projectSector.map(value => value.key),
    projectImplementationMode: projectImplementationMode.map(
      value => value.key
    ),
    recipientMinistry: recipientMinistry.map(value => value.key),
    recipientDistDept: recipientDistDept.map(value => value.key),
    projectProponent: projectProponent.map(value => value.key),
    bucket: bucket.map(value => value.key),
    milestone: milestone.map(value => value.key),
    bucketStatus: bucketStatus.map(value => value.key),
    milestoneStatus: milestoneStatus.map(value => value.key),
    projectLocation: projectLocation.map(value => value.key),
    projectZones: projectZones.map(value => value.key),
    districtProjectLocation: districtProjectLocation.map(value => value.key)
  };

  // after remove undefined null and empty array
  const cleanPayload = RemoveEmptyFieldsHelper(newpayload);
  cleanPayload["projectCost"] = projectCost.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });

  cleanPayload["delayedProject"] = delayedProject.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });

  cleanPayload["issueAgeing"] = issueAgeing.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });

  cleanPayload["costOverRun"] = costOverRun.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });

  return cleanPayload;
};

export const Project_Stage_Helper = function(key) {
  if (/(provisionally)/gi.test(key)) return "Provisionally Commissioned";

  if (/(commissioned)/gi.test(key)) return "Commissioned";

  if (/(construction)/gi.test(key)) return "Under Construction";

  if (/(noImplementation)/gi.test(key)) return "Under Development";

  return key;
};

export const transformIssueListPayload = (payload = {}) => {
  const {
    projectGroupBy = [],
    recipientState = [],
    recipientCenter = [],
    sponsoringMinistry = [],
    sponsoringDepartment = [],
    sponsoringState = [],
    projectStatus = [],
    projectStage = [],
    subCategory = [],
    category = [],
    stages = [],
    recipientDistrict = [],
    recipientDistrictStateDept = [],
    recipientStateDepartment = [],
    issueDistStateDept = [],
    taskCompletionDate = [],
    projectFlags = [],
    proponent = [],
    delayedProject = [],
    issueAgeing = [],
    costOverRun = [],
    projectCost = [],
    bucket = [],
    milestone = [],
    bucketStatus = [],
    milestoneStatus = [],
    centerState = [],
    escalationLevel = [],
    issueZones = []
  } = payload;
  const newpayload = {
    ...payload,
    projectGroupBy:
      Array.isArray(projectGroupBy) && projectGroupBy[0]
        ? projectGroupBy[0].checked
        : null,
    recipientState: recipientState.map(value => value.key),
    projectStatus: projectStatus.map(value => value.key),
    projectFlags: projectFlags.map(value => value.key),
    escalationLevel: escalationLevel.map(value => value.key),
    category: category.map(value => value.key),
    subCategory: category.map(value => value.key).length
      ? subCategory.map(value => value.key)
      : null,
    projectStage: projectStage.map(value => value.key),
    sponsoringState: sponsoringState.map(value => value.key),
    recipientCenter: recipientCenter.map(value => value.key),
    sponsoringMinistry: sponsoringMinistry.map(value => value.key),
    sponsoringDepartment: sponsoringDepartment.map(value => value.key),
    recipientDistrictStateDept: recipientDistrictStateDept.map(
      value => value.key
    ),
    stages: stages.map(value => value.key.toString()),
    proponent: proponent.map(value => value.key),
    recipientDistrict: recipientDistrict.map(value => value.key),
    recipientStateDepartment: recipientStateDepartment.map(value => value.key),
    bucket: bucket.map(value => value.key),
    milestone: milestone.map(value => value.key),
    bucketStatus: bucketStatus.map(value => value.key),
    milestoneStatus: milestoneStatus.map(value => value.key),
    centerState: centerState.map(value => value.key),
    issueZones: issueZones.map(value => value.key),
    issueDistStateDept:
      (recipientCenter && recipientCenter.length) ||
      (recipientState && recipientState.length)
        ? issueDistStateDept.map(value => value.key)
        : null
  };

  // after remove undefined null and empty array
  const cleanPayload = RemoveEmptyFieldsHelper(newpayload);
  cleanPayload["taskCompletionDate"] = taskCompletionDate.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });
  cleanPayload["delayedProject"] = delayedProject.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });
  cleanPayload["issueAgeing"] = issueAgeing.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });
  cleanPayload["costOverRun"] = costOverRun.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });
  cleanPayload["projectCost"] = projectCost.map(value => {
    const keys = value.key.split("-");
    return {
      from: keys[0] === "null" ? null : keys[0],
      to: keys[1] === "null" ? null : keys[1]
    };
  });
  return cleanPayload;
};

/*
Function to know the view for Responsiveness.
 */
export const isDesktopView = () => {
  const resolution = window.innerWidth;
  const isMobileOrTab = resolution >= 320 && resolution <= 1023;
  // return isDesktop
  return !isMobileOrTab;
};

export const _generateRouteComponent = (
  Component,
  permission,
  permissionList
) => {
  let permissionArr =
    permissionList &&
    permissionList.length &&
    filter(permissionList, ["name", permission]);
  if (permissionArr && permissionArr.length) {
    return Component;
  } else {
    return PageNotFound;
  }
};

export const handleQuillLanguage = html => {
  var hasInputValue = false;
  const reg = /[\u0900-\u097F]+/;
  let preval = html;
  if (reg.test(html)) {
    html = preval.substring(0, preval.length - 1);
    hasInputValue = true;
    return hasInputValue;
  } else {
    hasInputValue = false;
    return hasInputValue;
  }
};

export const handleLanguage = event => {
  var hasInputValue = false;
  const reg = /[\u0900-\u097F]+/;
  let preval = event.target.value;
  if (reg.test(event.target.value)) {
    event.target.value = preval.substring(0, preval.length - 1);
    hasInputValue = true;
    return hasInputValue;
  } else {
    hasInputValue = false;
    return hasInputValue;
  }
};
export const handlePaste = value => {
  if (value !== undefined) {
    var hasBadValue = false;
    var copiedText = value;
    const reg = /[\u0900-\u097F]+/;
    var filterString = "";
    for (var i = 0; i < copiedText.length; i++) {
      var charToCompare = copiedText.charAt(i);
      if (reg.test(charToCompare)) {
        hasBadValue = true;
        filterString = filterString.concat("^");
      } else {
        filterString = filterString.concat(charToCompare);
      }
    }
    return {
      filterString,
      hasBadValue
    };
  }
};
export const getAgendaTagsColor = type => {
  const colorCode = {
    scheduled: "schedule-button",
    concluded: "conclude-button",
    cancelled: "cancelled-button",
    postponed: "postponed-button",
    draft: "draft-button"
  };
  return colorCode[isString(type) && type.toLowerCase()] || "color-blue";
};

export const dateFormatWithCommas = date =>
  date
    ? moment(new Date(date))
        .local()
        .format("DD/MMM/YYYY,")
    : null;

export const removeUnderscoreFromText = value => {
  let formattedText = value.replace(/_/g, " ");
  return formattedText;
};

export const capitalizeFirstAfterSpace = str => {
  let words = str.split(" ");
  let capitalizedWords = [];
  for (let i = 0; i < words.length; i++) {
    if (words[i].length > 0) {
      // Check if word is not empty
      let firstLetter = words[i][0].toUpperCase();
      let restOfWord = words[i].slice(1).toLowerCase(); // Make the rest of the word lowercase
      capitalizedWords.push(firstLetter + restOfWord);
    }
  }
  return capitalizedWords.join(" ");
};

export const truncateData = data => {
  const maxLength = 30;

  if (data.length > maxLength) {
    return data.substring(0, maxLength);
  } else {
    return data;
  }
};

export const truncateAddress = data => {
  const maxLength = 50;

  if (data.length > maxLength) {
    return data.substring(0, maxLength);
  } else {
    return data;
  }
};

export const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 }
];

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem("chatSessionId");

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("chatSessionId", sessionId);
  }

  return sessionId;
};
